import React, { createContext, useState, useEffect } from "react";
import jwt_decode from "jwt-decode";
import { isEmpty, pick } from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
// import { toast } from "wc-toast";
import { apiGet, apiPost } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import useToastContext from "hooks/useToastContext";
import pathObj from "../utils/apiPath";
// import io from "socket.io-client";
const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
    let [user, setUser] = useState(() => localStorage.getItem("token") ? jwt_decode(localStorage.getItem("token")) : null);
    let [toast, setToast] = useState({ type: "success", message: "Success" });
    const [sidebarStatus, setSidebarStatus] = useState(localStorage.getItem('sidebar'))
    const [pageName,setPageName] = useState(localStorage.getItem("pageName") ? localStorage.getItem("pageName") :  'Dashboard')
    const navigate = useNavigate();
    const notification = useToastContext();
    const [loginMessage, setLoginMessage] = useState('Admin details updated successfully.')
    const updatePageName = (name) => {
        localStorage.setItem('pageName',name)
        setPageName(name)
    }

    let loginUser = async (body) => {
        document.getElementById("loader").classList.remove("hidden");
        const { status, data } = await apiPost(
            apiPath.loginUser,
            pick(body, ["email", "password"])
        );

        if (status === 200) {
            if (data.success) {
                const token = data?.results?.token || null;
                const refresh_token = data?.results?.refresh_token || null;
                localStorage.setItem("token", token);
                localStorage.setItem("refresh_token", refresh_token);
                localStorage.setItem("pageName","Dashboard");
                setPageName("Dashboard")
                setUser(jwt_decode(token))
               if(jwt_decode(token)?.role=='admin'){
                navigate("/dashboard")
               }
                if(jwt_decode(token)?.role=='subadmin'){
                navigate("/price")
               } 
               
                // navigate('/dashboard')
            } else {
                notification.error(data.message);
            }
        } else {
            // toast.error("API Error");
        }
        document.getElementById("loader").classList.add("hidden");
    };

    const updateProfile = async (data) => {
        try {
            const res = await apiPost(apiPath.editProfile, data);
            if(res?.data?.success) {
                const token = res?.data?.results?.token || null;
                const refresh_token = res?.data?.results?.refresh_token || null;
                localStorage.setItem("token", token);
                setLoginMessage(res?.data?.message)
                // localStorage.setItem("login_message", res?.data?.message)
                localStorage.setItem("refresh_token", refresh_token);
                setUser(jwt_decode(token));
            } else {
                notification.error(res?.data?.message);
            }
        } catch (err) {
            console.log('err:', err)
        }
    }

    const handleSidebar = () => {
        let s1 = localStorage.getItem('sidebar')
        localStorage.setItem('sidebar', s1 == 'open' ? 'close' : 'open')
        setSidebarStatus(s1 == 'open' ? 'close' : 'open')
    }

    let logoutUser = () => {
        setUser(null);
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
        navigate("/login");
    };

    // useEffect(() => {

    // }, []);
    let contextData = {
        user,
        loginUser: loginUser,
        logoutUser: logoutUser,
        updateProfile: updateProfile,
        sidebarStatus: sidebarStatus,
        handleSidebar,
        pageName,
        updatePageName,
        loginMessage:loginMessage,
    };
    return (
        <AuthContext.Provider value={contextData}>
            {children}
        </AuthContext.Provider>
    );
};
